import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { LinkModule } from '@com-delta-idp/mnx-ui-kit';
import {
  ChangeStylesDirective,
  DividerComponent,
  EntryItemComponent,
  ToggleAreaComponent,
  TooltipDirective
} from '@com-delta-omnichannel/aura';
import { EarnsSummaryComponent } from './earns-summary.component';

@NgModule({
  declarations: [EarnsSummaryComponent],
  imports: [
    LinkModule,
    EntryItemComponent,
    ToggleAreaComponent,
    DividerComponent,
    ChangeStylesDirective,
    TooltipDirective
  ],
  exports: [EarnsSummaryComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class EarnsSummaryModule {}
